<template>
  <div class="message">
      <div class="white-wrap" :class="{'add-device':add_device_class}" :style="{height:myHeight,width:myWidth}">
        <slot name="content"></slot>
      </div>
  </div>
</template>
<script>
export default {
  props: {
      add_device_class: Boolean,
      myHeight:String,
      myWidth:String
  }
}
</script>

<style scoped lang="less">
  .message{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background-color: rgba(81,81,81,0.35);

    .white-wrap{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%); //向左移动自身宽度的50%
      width: 490px;
      height: 265px;
        background-color: #FCFCFC;
        border-radius: 7px;
      box-sizing: border-box;
      box-shadow: 0px 0px 5px 2px  rgba(193,193,193,.5);
        overflow: hidden;
    }
      .add-device{
          width: 369px;
          height: 234px;
      }


  }
</style>
